document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.querySelector( '.iwish-custom-overlay');
  if (!overlay) {return;}
  const popup = overlay.querySelector('.iwish-quickview-popup');
  const content = overlay.querySelector('.iwish-quickview-content');
  const closeButton = overlay.querySelector('.iwish-popup-close');
  document.addEventListener('click',function (event) {
      const trigger = event.target.closest('.iwish-quickview-trigger');
      if (!trigger) {return;}
      event.preventDefault();
      const productUrl = trigger.dataset.productUrl;
      if (!productUrl) {return;}
      openQuickView();
      loadProduct(productUrl);
    }
  );
  function openQuickView() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden','true');
    document.body.style.overflow = 'hidden';
  }
  function closeQuickView() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden','false');
    document.body.style.overflow = '';
    content.innerHTML = '';
  }
  closeButton.addEventListener('click',function () {
      closeQuickView();
    }
  );
  overlay.addEventListener('click',function (event) {
      if (event.target === overlay) {
        closeQuickView();
      }
    }
  );
  document.addEventListener('keydown',function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-open')){
        closeQuickView();
      }
    }
  );

async function loadProduct(productUrl) {
  content.innerHTML = `<div class="iwish-quickview-loading">Loading...</div>`;
  try {
    const urlObject = new URL(productUrl,window.location.origin);
    urlObject.pathname = urlObject.pathname.replace(/\/$/, '');
    urlObject.pathname = urlObject.pathname.replace(/\.js$/, '');
    urlObject.pathname += '.js';
    urlObject.search = '';
    const url = urlObject.toString();
    const response = await fetch(url, { method: 'GET', headers: {'Accept': 'application/json'}});
    if (!response.ok) {
      throw new Error('Product request failed: ' + response.status);
    }
    const product = await response.json();
    if (!product || !product.id || !product.variants){
      throw new Error('Invalid Shopify product response.');
    }
    renderProduct(product);
  } catch (error) {console.error('Quick View Error:',error);
    content.innerHTML = `<div class="iwish-quickview-loading">Unable to load product.</div>`;
  }
}
  function renderProduct(product) {
    const firstVariant = getInitialVariant(product);
    if (!firstVariant) {
      content.innerHTML = `<div class="iwish-quickview-loading"> Product unavailable.</div>`;
      return;
    }
    let html = '';
    html += `<h2 class="iwish-quickview-title">${escapeHTML(product.title)}</h2>`;
    html += `<div class="iwish-quickview-price">${formatMoney(firstVariant.price)}</div>`;
    if (product.options && product.options.length && !(product.options.length === 1 && product.options[0] === 'Title')) {
      html += `<div class="product-form__controls-groupss">`;
      product.options.forEach(
        function (optionName, optionIndex) {
          const values = getOptionValues(product, optionIndex);
          html += `<div class="product-options" data-option-position="${optionIndex + 1}"><h5>${escapeHTML(optionName)}</h5><div class="product-option-valuess">`;
          values.forEach(
            function (value, valueIndex) {
              const checked = isValueSelected(firstVariant, optionIndex, value);
              html += `<label class="variant-pill">
                  <input type="radio" hidden name="quick-view-option-${product.id}-${optionIndex}" value="${escapeAttribute(value)}"
                    data-option-position="${optionIndex + 1}" ${checked ? 'checked' : ''}>
                  <span> ${escapeHTML(value)} </span></label>`;
            }
          );
          html += `</div>
            </div>`;
        }
      );
      html += `</div>`;
    }
    html += `<input type="hidden" class="selected-variant-id" value="${firstVariant.id}">`;
    html += `<button type="button" class="iWishAdd iwish-quickview-add-button" data-product="${product.id}"
        data-variant-id="${firstVariant.id}" ${firstVariant.available ? '' : ''}>
      </button>`;
    content.innerHTML = html;
    const iwishButton =content.querySelector('.iwish-quickview-add-button');
    if (iwishButton && typeof iWish !== 'undefined') {
      if (iwishButton.innerHTML.trim() === '' && window.iWishData && window.iWishData.iwish_add_txt) {
        iwishButton.innerHTML = window.iWishData.iwish_add_txt;
      }
      iWish.iwishAddClick(iwishButton);
      const selectedInput = content.querySelector('.selected-variant-id');
      if (selectedInput) {
        iWish.checkIwish(selectedInput);
      }
    }

initializeVariants(product);
initializeAddButton(product);
  }
  function getInitialVariant(product) {
    return (product.variants.find( function (variant) {return variant.available;}) || product.variants[0]);
  }
  function getOptionValues(product, optionIndex) {
    const values = [];
    product.variants.forEach(function (variant) {
        const value = variant.options[optionIndex];
        if (value && !values.includes(value)) {
          values.push(value);
        }
      }
    );
    return values;
  }
  function isValueSelected(variant, optionIndex, value) {
    return (variant.options[optionIndex] === value);
  }
  function initializeVariants(product) {
    const selectedInput = content.querySelector('.selected-variant-id');
    const optionGroups = content.querySelectorAll('.product-options');
    optionGroups.forEach(function (group) {
        const inputs = group.querySelectorAll('input[type="radio"]');
        inputs.forEach(function (input) {
            input.addEventListener('change',function () {
                updateVariant(product);
              }
            );
          }
        );
      }
    );
    updateVariant(product);
    function updateVariant(product) {
      const selectedOptions = [];
      optionGroups.forEach(function (group) {
          const position = Number(group.dataset.optionPosition);
          const selected = group.querySelector('input:checked');
          if (selected) {
            selectedOptions[position - 1] = selected.value;
          }
        }
      );
      const variant = product.variants.find(function (variant) {
            return variant.options.every(
              function (option, index) {
                return (option === selectedOptions[index]);
              }
            );
          }
        );
      updateAvailableOptions(product, selectedOptions);
      if (!variant) {
        if (selectedInput) {selectedInput.value = '';}
        return;
      }
      if (selectedInput) {
        selectedInput.value = variant.id;
      }
      const button = content.querySelector('.iwish-quickview-add-button');
      if (button) {
        button.setAttribute('data-variant',String(variant.id));
        if (
          typeof iWish !== 'undefined' && selectedInput
        ) {
          iWish.checkIwish(selectedInput, button);
        }
      }
      const price =
        content.querySelector('.iwish-quickview-price');
      if (price) {
        price.textContent = formatMoney(variant.price);
      }
    }
  }
  function updateAvailableOptions(product, selectedOptions) {
    const groups = content.querySelectorAll('.product-options');
      groups.forEach(function (group) {
        const position = Number(group.dataset.optionPosition);
        const inputs = group.querySelectorAll('input[type="radio"]');
        inputs.forEach(
          function (input) {
            const testOptions = selectedOptions.slice();
            testOptions[position - 1] = input.value;
            const available = product.variants.some(
                function (variant) {
                  if (!variant.available) {
                    return false;
                  }
                  return variant.options.every(
                    function (option, index) {
                      if (testOptions[index] === undefined) {
                        return true;
                      }
                      return (option === testOptions[index]);
                    }
                  );
                }
              );
            const pill = input.closest('.variant-pill');
            if (pill) {
              pill.classList.toggle('disabled', !available);
            }
          }
        );
      }
    );
  }

  function initializeAddButton(product) {
    const button = content.querySelector('.iwish-quickview-add-button');
    if (!button) {return;}
  }

 function formatMoney(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents).replace(/\$/, 'Rs. ');
  }

  return '₹' + (Number(cents) / 100).toFixed(2);
}
  function escapeHTML(value) {
    return String(value)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }
  function escapeAttribute(value) {
    return escapeHTML(value);
  }
  
});
